import React, { useState, useEffect } from "react";
import "./Css/AddStaff.css";

import SideBar from "./SideBar";
import Header from "./Header";
import Loader from "./Loader.js";
import OpenMenu from "../assets/menu_open.png";
import editImg from "../assets/edit_square.png";
import GreyArrow from "../assets/greyLeftAr.png";
import DropDwn from "../assets/drop-dwn.png";
import Person from "../assets/person.png";
import "react-datepicker/dist/react-datepicker.css";
import {
  Open_Menu_text,
  AddStaffPageText,
  options_gender,
  options_blood_group,
} from "./../CommonJquery/WebsiteText";
import {
  handleEmailChange,
  handleNumbersChange,
  handleURLChange,
  handleAphabetsChange,
  handleError,
  handlePasswordChange,
  check_vaild_save,
  combiled_form_data,
  handleSuccessSession,
  computeTodayDate,
  handlecoordinatory_no,
  handlepersonal_id_no,
  empty_form,
  cencelChanges,
  calculateMaxDate,
  calculateMinJoinDate,
  calculateMaxJoinDate,
} from "../CommonJquery/CommonJquery";
import {
  server_post_data,
  save_update_agent,
  get_all_agent,
  APL_LINK,
} from "../ServiceConnection/serviceconnection.js";
import { useLocation } from "react-router-dom";
function AddAgent() {
  const location = useLocation();
  const currentUrl = location.pathname.substring(1);
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [editorDataMainID, setEditorDatMainID] = useState("0");
  const [editStaffData, seteditStaffData] = useState([]);
  const [editOldImageData, seteditOldImageData] = useState([]);
  const [designations, setdesignations] = useState([]);
  const [dynaicimage, setDynaicimage] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
  const [permanentAddress, setPermanentAddress] = useState("");
  const [temporaryAddress, setTemporaryAddress] = useState("");
  const [copyAddress, setCopyAddress] = useState(false);

  const handleSaveChangesdynamic = async (form_data, url_for_save) => {
    let vaild_data = check_vaild_save(form_data);

    if (vaild_data) {
      setshowLoaderAdmin(true);
      let fd_from = combiled_form_data(form_data, dynaicimage);
      fd_from.append("main_id", editorDataMainID);
      fd_from.append("old_image_link", editOldImageData);
      await server_post_data(url_for_save, fd_from)
        .then((Response) => {
        
          setshowLoaderAdmin(false);
          if (Response.data.error) {
            handleError(Response.data.message);
          } else {
            handleSuccessSession(Response.data.message, "/View_agent");
            empty_form(form_data);
          }
        })
        .catch((error) => {
          setshowLoaderAdmin(false);
        });
    }
  };

  const openCustomDatePicker = (customDatePickerInput_id) => {
    document.getElementById(customDatePickerInput_id).focus();
  };

  useEffect(() => {
    const url = currentUrl;
    const parts = url.split("/");
    const start_date = "";
    const end_date = "";
    const flag = "3";
    let call_id = "0";
    if (parts.length !== 1) {
      call_id = parts[1];
    }
    const input = document.getElementById("searchInput");
    const autocomplete = new window.google.maps.places.Autocomplete(input);

    autocomplete.addListener("place_changed", function () {
      const place = autocomplete.getPlace();
      let full_address = place.address_components;
      let formatted_address = place.formatted_address;
      let length_data = place.address_components.length;
      let citys = "";
      let state = "";
      let country = "";
      let tehsil = "";
      for (let i = 0; i < length_data; i++) {
        if (full_address[i].types[0] === "administrative_area_level_1") {
          state = full_address[i].long_name;
        } else if (full_address[i].types[0] === "country") {
          country = full_address[i].long_name;
        } else if (full_address[i].types[0] === "administrative_area_level_2") {
          citys = full_address[i].long_name;
        } else if (full_address[i].types[0] === "locality") {
          tehsil = full_address[i].long_name;
        }
      }
      if (tehsil !== "") {
        citys = tehsil;
      }
      setPermanentAddress(formatted_address);
      document.getElementById("city").value = citys;
      document.getElementById("state").value = state;
      document.getElementById("country").value = country;
    });
    master_data_get(start_date, end_date, flag, call_id);
  }, []);

  const master_data_get = async (start_date, end_date, flag, call_id) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("start_date", start_date);
    fd.append("end_date", end_date);
    fd.append("flag", flag);
    fd.append("call_id", call_id);
    await server_post_data(get_all_agent, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          if (Response.data.message.data_staff.length > 0) {
            seteditStaffData(Response.data.message.data_staff[0]);
            setDynaicimage({
              event_list_image_show:
                APL_LINK +
                Response.data.message.data_link_image +
                Response.data.message.data_staff[0].admin_image,
            });
            setEditorDatMainID(Response.data.message.data_staff[0].primary_id);
            seteditOldImageData(
              Response.data.message.data_staff[0].admin_image
            );
            setPermanentAddress(
              Response.data.message.data_staff[0].admin_manual_adrress
            );
            setTemporaryAddress(
              Response.data.message.data_staff[0].admin_temorary_adrress
            );
            if (Response.data.message.data_staff[0].coordinatory_no != "") {
              setIsCheckboxChecked(true);
            }
          }
          setdesignations(Response.data.message.data_designation);
        }

        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };
  const handleCheckboxChange = () => {
    setIsCheckboxChecked(!isCheckboxChecked);
    if (!isCheckboxChecked) {
      document.getElementById("personal_identity_no").value = "";
    }
  };

  const handleCheckboxChange2 = () => {
    setCopyAddress(!copyAddress); // Toggle checkbox state
    if (!copyAddress) {
      setTemporaryAddress(permanentAddress); // Copy permanent address to temporary address
    } else {
      setTemporaryAddress(""); // Clear temporary address
    }
  };

  return (
    <div className="dashboard">
      {showLoaderAdmin && <Loader />}
      <div className="dashboard_container">
        <div className="page_content">
          <div className="page_content_container">
            <Header />
            <div className="pageCntn_head">
              <div className="pageNameDiv">
                {location.pathname.includes("/Edit_agent") ? (
                  <p>Update Agent</p>
                ) : (
                  <p>Add Agent</p>
                )}
                <img src={GreyArrow} alt="Rapid Car Leasing" />
              </div>
            </div>

            <div className="page_body mt-4">
              <div className="container-lg">
                {" "}
                <div className="addStaffForms">
                  <form id="addNewStaff">
                    <div className="row m-0">
                      <div className="col-lg-12">
                        <div className="personalForm ">
                          <h3>{AddStaffPageText.Personal_Details}</h3>
                          <div className="staffForm_container">
                            <div className="row m-0">
                              <div className="col-md-4">
                                <div className="addstaffInputs ">
                                  <div className="inpContainer">
                                    <div className="person_image image_icon_position image_icon_position1">
                                      <input
                                        type="text"
                                        id="agent_name"
                                        name="agent_name"
                                        tabIndex="1"
                                        placeholder={
                                          AddStaffPageText.Placeholder_Name
                                        }
                                        minLength={3}
                                        maxLength={75}
                                        className=" trio_mandatory form-control  input_field_custom1 "
                                        // onInput={handleAphabetsChange}
                                        defaultValue={
                                          editStaffData.agent_name || ""
                                        }
                                      />
                                      <span className="condition_error"></span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-4">
                                {" "}
                                <div className="inpContainer">
                                  <div className="person_image image_icon_position1">
                                    <input
                                      type="text"
                                      id="agent_id"
                                      name="agent_id"
                                      placeholder={
                                        AddStaffPageText.Personal_id_no
                                      }
                                      defaultValue={
                                        editStaffData.agent_id || ""
                                      }
                                      onChange={handlepersonal_id_no}
                                      minLength={1}
                                      maxLength={76}
                                      className=" form-control trio_mandatory input_field_custom1"
                                    />

                                    <span className="condition_error"></span>
                                  </div>
                                </div>
                              </div>

                              <div className="col-md-4 MARGINaDDaGENT">
                                <div className="inpContainer">
                                  <div className="person__email_image image_icon_position1 mt-2">
                                    <input
                                      type="text"
                                      name="agent_email2"
                                      placeholder={AddStaffPageText.Add_Email}
                                      minLength={4}
                                      maxLength={72}
                                      className="trio_email trio_mandatory form-control  input_field_custom1 "
                                      onInput={(e) => handleEmailChange(e)}
                                      defaultValue={
                                        editStaffData.agent_email2 || ""
                                      }
                                    />
                                    <span className="condition_error"></span>
                                  </div>
                                  <p className="noteMsg">
                                    {AddStaffPageText.User_Id_text}
                                  </p>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="inpContainer">
                                  <div className="person__phone_image image_icon_position1">
                                    <input
                                      type="text"
                                      name="agent_mobile_no"
                                      placeholder={
                                        AddStaffPageText.Phone_Number
                                      }
                                      minLength={4}
                                      maxLength={10}
                                      className="trio_no trio_mandatory form-control input_field_custom2 "
                                      onInput={(e) => handleNumbersChange(e)}
                                      defaultValue={
                                        editStaffData.agent_mobile_no || ""
                                      }
                                    />
                                    <span className="condition_error"></span>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="inpContainer">
                                  <div className="person__phone_image image_icon_position1">
                                    <input
                                      type="text"
                                      id="agent_mobile_no2"
                                      name="agent_mobile_no2"
                                      placeholder={
                                        AddStaffPageText.Alt_Phone_Number
                                      }
                                      maxLength={10}
                                      minLength={4}
                                      className="trio_no  form-control input_field_custom2 "
                                      onInput={(e) => handleNumbersChange(e)}
                                      defaultValue={
                                        editStaffData.agent_mobile_no2 || ""
                                      }
                                    />
                                    <span className="condition_error"></span>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-12">
                                <div className="inpContainer ">
                                  <div className="image_icon_position1">
                                    <label className="no_prsnl_id">
                                      {AddStaffPageText.Permanent_Address}
                                    </label>
                                    <textarea
                                      type="text"
                                      rows="7"
                                      id="searchInput"
                                      autoComplete="off"
                                      name="map_address"
                                      maxLength={250}
                                      minLength={5}
                                      placeholder={
                                        AddStaffPageText.Permanent_addressplaceholder
                                      }
                                      value={permanentAddress}
                                      onChange={(e) =>
                                        setPermanentAddress(e.target.value)
                                      }
                                      className="trio_mandatory form-control input_field_custom3"
                                      defaultValue={
                                        editStaffData.map_address || ""
                                      }
                                    ></textarea>
                                    <span className="condition_error"></span>
                                  </div>
                                </div>
                              </div>
                              <div className="form-row hidden">
                                <div className="col-md-4 mb-3">
                                  <label htmlFor="validationCustom01">
                                    City
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control  searchInput_google"
                                    name="city"
                                    id="city"
                                    autoComplete="off"
                                    maxLength={100}
                                    minLength={3}
                                    onInput={handleAphabetsChange}
                                    placeholder={AddStaffPageText.City_Name}
                                    defaultValue={editStaffData.city || ""}
                                  />
                                  <span className="condition_error"></span>
                                </div>
                                <div className="col-md-4 mb-3">
                                  <label htmlFor="validationCustom01">
                                    {AddStaffPageText.State}
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control  "
                                    name="state"
                                    id="state"
                                    autoComplete="off"
                                    maxLength={100}
                                    onInput={handleAphabetsChange}
                                    placeholder={AddStaffPageText.Enter_State}
                                    defaultValue={editStaffData.state || ""}
                                  />
                                  <span className="condition_error"></span>
                                </div>
                                <div className="col-md-4 mb-3">
                                  <label htmlFor="validationCustom01">
                                    {AddStaffPageText.Country}
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control  "
                                    name="country"
                                    id="country"
                                    autoComplete="off"
                                    maxLength={100}
                                    onInput={handleAphabetsChange}
                                    placeholder={AddStaffPageText.Enter_Country}
                                    defaultValue={editStaffData.country || ""}
                                  />
                                  <span className="condition_error"></span>
                                </div>
                              </div>
                              <div className="col-md-12">
                                <div className="inpContainer">
                                  <div className="no_prsnl_id">
                                    <div className="rememberMe">
                                      <input
                                        type="checkbox"
                                        id="adress_box"
                                        tabIndex="2"
                                        className="hidden-checkbox"
                                        onChange={handleCheckboxChange2}
                                      />

                                      <label
                                        htmlFor="adress_box"
                                        className="checkbox-label labelCheckbox"
                                        tabIndex="2"
                                      >
                                        {AddStaffPageText.Same_Address}
                                      </label>
                                    </div>
                                  </div>

                                  <div className="image_icon_position1">
                                    <label className="no_prsnl_id">
                                      Present Street Address
                                      {/* {AddStaffPageText.Temporary_Address} */}
                                    </label>
                                    <textarea
                                      type="text"
                                      id="searchInput2"
                                      rows="4"
                                      name="present_street_address"
                                      maxLength={250}
                                      minLength={5}
                                      value={temporaryAddress}
                                      // placeholder={
                                      //     AddStaffPageText.Permanent_addressplaceholder
                                      // }
                                      placeholder="present street address"
                                      onChange={(e) =>
                                        setTemporaryAddress(e.target.value)
                                      }
                                      className="form-control input_field_custom3 "
                                      defaultValue={
                                        editStaffData.present_street_address ||
                                        ""
                                      }
                                    ></textarea>
                                    <span className="condition_error"></span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="saveFormBtns">
                          <button
                            className="btnCancel"
                            type="button"
                            onClick={cencelChanges}
                          >
                            {AddStaffPageText.cencel_text}
                          </button>

                          <button
                            className="btnSave"
                            type="button"
                            onClick={() =>
                              handleSaveChangesdynamic(
                                "addNewStaff",
                                save_update_agent
                              )
                            }
                          >
                            {location.pathname.includes("/Edit_agent")
                              ? AddStaffPageText.update_text
                              : AddStaffPageText.save_text}
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddAgent;
